var render = function () {
  var _vm$form, _vm$form$meta, _vm$form2, _vm$form2$meta, _vm$form3, _vm$form3$meta, _vm$form4, _vm$form5, _vm$form6;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value ? _c('div', {
    staticClass: "form-container"
  }, [_c('v-divider', {
    staticClass: "primary border-2"
  }), _c('div', {
    staticClass: "py-20 px-md-10 py-md-36"
  }, [_c('div', {
    staticClass: "mt-n8 mt-md-n14"
  }, [_c('myinfo-row', {
    attrs: {
      "label": "이름"
    }
  }, [_vm._v(" " + _vm._s(((_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$meta = _vm$form.meta) === null || _vm$form$meta === void 0 ? void 0 : _vm$form$meta.name) || "-") + " ")]), _c('myinfo-row', {
    attrs: {
      "label": "연락처"
    }
  }, [_vm._v(" " + _vm._s(((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : (_vm$form2$meta = _vm$form2.meta) === null || _vm$form2$meta === void 0 ? void 0 : _vm$form2$meta.phone) || "-") + " ")]), _c('myinfo-row', {
    attrs: {
      "label": "이메일"
    }
  }, [_vm._v(" " + _vm._s(((_vm$form3 = _vm.form) === null || _vm$form3 === void 0 ? void 0 : (_vm$form3$meta = _vm$form3.meta) === null || _vm$form3$meta === void 0 ? void 0 : _vm$form3$meta.email) || "-") + " ")])], 1)]), _c('div', {
    staticClass: "py-20 px-md-10 py-md-36"
  }, [_c('div', {
    staticClass: "mt-n8 mt-md-n14"
  }, [_c('myinfo-row', {
    attrs: {
      "label": "제목"
    }
  }, [_vm._v(" " + _vm._s(((_vm$form4 = _vm.form) === null || _vm$form4 === void 0 ? void 0 : _vm$form4.subject) || "-") + " ")]), _c('myinfo-row', {
    attrs: {
      "label": "내용"
    }
  }, [_vm._v(" " + _vm._s(((_vm$form5 = _vm.form) === null || _vm$form5 === void 0 ? void 0 : _vm$form5.content) || "-") + " ")])], 1)]), _c('v-card', {
    staticClass: "grey-ef",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('div', {
    staticClass: "page-text",
    domProps: {
      "innerHTML": _vm._s(((_vm$form6 = _vm.form) === null || _vm$form6 === void 0 ? void 0 : _vm$form6.reply) || '답변 내용이 없습니다.')
    }
  })])], 1), _c('div', {
    staticClass: "mt-30 mt-md-50"
  }, [_c('div', {
    staticClass: "v-btn--group v-btn--group--large"
  }, [_c('v-btn', {
    staticClass: "w-100 mw-220px",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "grey-cb"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("목록으로")])])], 1)])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }